import { useEffect, useState, useRef } from 'react';
import Popup from '../popup/popup';
import InputText from '../inputs/input-text';
import ButtonPseudo from '../button/button-pseudo';
import ButtonPrimary from '../button/button-primary';
import IconLoader from '../icons/loader';
import usePrevious from '../../hooks/use-previous';
import { TransactionSignaturePopupTypes } from './types';

import styles from './transaction.module.css';

export default function SignaturePopup({
  signaturePopupVisible = false,
  validateCode,
  validateCodeInProgress,
  errorMessageSignature = '',
  onSignatureCancelClick,
}: TransactionSignaturePopupTypes) {
  const [otpCode, setOtpCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const inputRef = useRef<HTMLInputElement | null>(null);

  const prevSignaturePopupVisible = usePrevious(signaturePopupVisible);

  useEffect(() => {
    setErrorMessage(errorMessageSignature);
  }, [errorMessageSignature]);

  useEffect(() => {
    if (!signaturePopupVisible && prevSignaturePopupVisible) {
      setOtpCode('');
      setErrorMessage('');
    }
  }, [prevSignaturePopupVisible, signaturePopupVisible]);

  useEffect(() => {
    if (otpCode && validateCode && otpCode.length === 6) {
      validateCode(otpCode);
    }
  }, [otpCode]);

  useEffect(() => {
    if (signaturePopupVisible) {
      setTimeout(() => {
        if (inputRef && inputRef.current) {
          inputRef.current.focus();
        }
      }, 10);
    }
  }, [inputRef, signaturePopupVisible]);

  return (
    <Popup
      title="Confirm transaction creation"
      onCancelClick={() => {
        if (onSignatureCancelClick) {
          onSignatureCancelClick();
        }

        setOtpCode('');
      }}
      isVisible={signaturePopupVisible}
      parent={document.getElementById('signature-popup') as HTMLElement}
      popupClassName={styles.signaturePopup}
    >
      <>
        <div className={styles.formGroup}>
          <InputText
            value={otpCode}
            onChange={(e) => {
              setOtpCode(e.target.value);
              setErrorMessage('');
            }}
            placeholder="Enter OTP-code here"
            name="otpCode"
            error={errorMessage}
            inputRef={inputRef}
            disabled={validateCodeInProgress}
            onKeyUp={(e) => {
              if (e.key === 'Enter' && validateCode) {
                validateCode(otpCode);
              }
            }}
            maxLength={6}
          />
        </div>
        <div className={styles.controls}>
          <ButtonPseudo
            text="Cancel"
            onClick={() => {
              if (onSignatureCancelClick) {
                onSignatureCancelClick();
              }

              setOtpCode('');
            }}
            bold
          />
          <ButtonPrimary
            text={validateCodeInProgress ? '' : 'Confirm'}
            onClick={() => validateCode && validateCode(otpCode)}
            className={styles.signatureButton}
            icon={validateCodeInProgress ? <IconLoader /> : undefined}
            disabled={validateCodeInProgress || Boolean(errorMessage)}
            bold
          />
        </div>
      </>
    </Popup>
  );
}
